import React, { useRef, useState } from 'react';
import './Testimonials.css';
import testimonial1 from '../../assets/images/testimonials/testimonial-1.jpg';
import testimonial2 from '../../assets/images/testimonials/testimonial-2.jpg';
import testimonial3 from '../../assets/images/testimonials/testimonial-3.jpg';
import testimonial4 from '../../assets/images/testimonials/testimonial-4.jpg';
import testimonial5 from '../../assets/images/testimonials/testimonial-5.jpg';

interface Testimonial {
  id: number;
  name: string;
  years: string;
  text: string;
  imageUrl: string;
  backgroundColor?: string;
}

const Testimonials: React.FC = () => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);

  const testimonials: Testimonial[] = [
    {
      id: 1,
      name: "阿煒",
      years: "4年",
      text: "「好鐘意係度上堂的氣氛，同學仔又會互相鼓勵，一齊進步🔥」",
      imageUrl: testimonial1,
      backgroundColor: "#4d4d4d"
    },
    {
      id: 2,
      name: "Tom",
      years: "2年",
      text: "「跟JSW玩咗兩年街頭健身，汗水換來力量與自信，每一步都是突破，每一天都在超越自我！」",
      imageUrl: testimonial2,
      backgroundColor: "#ffffff"
    },
    {
      id: 3,
      name: "Brian",
      years: "4年",
      text: "「街頭健身就係不斷突破自己既極限！」",
      imageUrl: testimonial3,
      backgroundColor: "#4d4d4d"
    },
    {
      id: 4,
      name: "Dika",
      years: "4年",
      text: "「原來女仔都做到街頭健身好型嘅動作㗎，好玩又操fit咗。」",
      imageUrl: testimonial4,
      backgroundColor: "#ffffff"
    },
    {
      id: 5,
      name: "Kings",
      years: "3年",
      text: "「跟咗JSW 3年，我最大嘅得着就係佢多年種黎做運動員嘅心理質素。唔單止根據我嘅需求度身訂造訓練課程，最重要係佢係我每1set最後一下都比最大力嘅鼓勵和支持，另我3年黎不斷突破自己。」",
      imageUrl: testimonial5,
      backgroundColor: "#4d4d4d"
    }
  ];

  const handleScroll = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  const scroll = (direction: 'left' | 'right') => {
    if (scrollContainerRef.current) {
      const { clientWidth } = scrollContainerRef.current;
      const scrollAmount = clientWidth * 0.7;
      scrollContainerRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="testimonials" className="testimonials-section section">
      <div className="section-container">
        <h2 className="section-title">學生評價</h2>
        
        <div className="testimonials-carousel-container">
          {showLeftArrow && (
            <button className="scroll-arrow left" onClick={() => scroll('left')}>
              &#10094;
            </button>
          )}
          
          <div 
            className="testimonials-carousel" 
            ref={scrollContainerRef}
            onScroll={handleScroll}
          >
            {testimonials.map(testimonial => (
              <div 
                key={testimonial.id} 
                className="testimonial-card"
                style={{ 
                  backgroundColor: testimonial.backgroundColor || '#ffffff',
                  color: testimonial.backgroundColor === '#ffffff' ? '#333' : '#fff'
                }}
              >
                <div className="quote-mark">❝</div>
                <div className="testimonial-content">
                  <p className="testimonial-text">{testimonial.text}</p>
                  
                  <div className="testimonial-footer">
                    <div className="testimonial-image-container">
                      <img 
                        src={testimonial.imageUrl} 
                        alt={`${testimonial.name}'s testimonial`} 
                        className="testimonial-image"
                        onError={(e) => {
                          // Fallback to initial letter if image fails to load
                          const target = e.target as HTMLImageElement;
                          const parent = target.parentElement;
                          if (parent) {
                            const initial = testimonial.name.charAt(0);
                            const bgColor = testimonial.backgroundColor === '#ffffff' ? '#ddd' : '#555';
                            const textColor = testimonial.backgroundColor === '#ffffff' ? '#333' : '#fff';
                            
                            const div = document.createElement('div');
                            div.className = 'testimonial-image';
                            div.textContent = initial;
                            div.style.backgroundColor = bgColor;
                            div.style.color = textColor;
                            div.style.display = 'flex';
                            div.style.alignItems = 'center';
                            div.style.justifyContent = 'center';
                            div.style.fontWeight = 'bold';
                            div.style.fontSize = '20px';
                            
                            parent.replaceChild(div, target);
                          }
                        }}
                      />
                    </div>
                    <div className="testimonial-author">
                      <h4>{testimonial.name}</h4>
                      <p>學生年資：{testimonial.years}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {showRightArrow && (
            <button className="scroll-arrow right" onClick={() => scroll('right')}>
              &#10095;
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
